import { initLocalOptionsWithDefaultOption } from '../Selectors/Option';

export const roofTypes = initLocalOptionsWithDefaultOption([
  {
    identifier: 'roof_type_trapezoidal',
    externalIdentifier: 'roof_type_trapezoidal',
    variant: 'roof_type_trapezoidal',
    title: 'Trapezblech',
  },
  {
    identifier: 'roof_type_sandwich',
    externalIdentifier: 'roof_type_sandwich',
    variant: 'roof_type_sandwich',
    thickness: 40,
    title: 'Sandwich',
  },
  {
    identifier: 'thermo',
    externalIdentifier: 'roof_type_thermo',
    variant: 'roof_type_thermo',
    title: 'Thermo',
  },
  {
    identifier: 'pvc',
    externalIdentifier: 'roof_type_pvc',
    variant: 'roof_type_pvc',
    title: 'PVC roof',
  },
]);

export const defaultRoofType = roofTypes[0];

export function isTextileRoof(obj) {
  return obj?.identifier === 'textile';
}

export function isPVCRoof(obj) {
  return obj?.identifier === 'pvc';
}

export function isThermoRoof(obj) {
  return obj?.identifier === 'thermo';
}
